import { React, useState,useContext,useEffect } from 'react';
import { Box, Typography, Button, Grid, Avatar, Paper, Divider, Container, ListItem, ListItemAvatar, ListItemText, Dialog, DialogActions, Card } from '@mui/material';
import { Business, LocalHospital, School, Store, Science, MoreHoriz, CardTravel, HomeWork, AttachMoney, AccountBalance, Gavel, Computer } from '@mui/icons-material';
import { Carousel } from 'react-bootstrap';
import { motion } from 'framer-motion';
import ReactPlayer from 'react-player/youtube';
import { useNavigate,useLocation  } from 'react-router-dom';
import { KeyboardArrowDown } from '@mui/icons-material';
import Login from './Login';
import { AuthContext } from '../context/AuthContext';
import Newsandevents from  './Newsandevents'
import axios from 'axios';
import LoadingScreen from './LoadingScreen';
const industries = [
  { name: 'Insurance', icon: <Business />, color: '#1976d2' },
  { name: 'Healthcare', icon: <LocalHospital />, color: '#e53935' },
  { name: 'Education', icon: <School />, color: '#8e24aa' },
  { name: 'Small Industries', icon: <Store />, color: '#f57c00' },
  { name: 'Research', icon: <Science />, color: '#43a047' },
  { name: 'Travel', icon: <CardTravel />, color: '#00acc1' },
  { name: 'Real Estate', icon: <HomeWork />, color: '#6d4c41' },
  { name: 'Finance', icon: <AttachMoney />, color: '#2e7d32' },
  { name: 'Banking', icon: <AccountBalance />, color: '#3949ab' },
  { name: 'Legal', icon: <Gavel />, color: '#5e35b1' },
  { name: 'IT', icon: <Computer />, color: '#546e7a' },
  { name: 'Others', icon: <MoreHoriz />, color: '#546e7a' },
];
const AboutPage = () => {
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  const [openDialog, setOpenDialog] = useState(false);

  const handleDialogOpen = () => setOpenDialog(true);
  const handleDialogClose = () => setOpenDialog(false);
  const { isAuthenticated } = useContext(AuthContext);
  const [dynamicData, setDynamicData] = useState({});
  const [achievements, setAchievements] = useState([]);

  const [associations,setassociations]=useState([])
  useEffect(() => {
    const currentPath = location.pathname;
    if (isAuthenticated && currentPath === '/') {
      navigate('/home');
    }
  }, [isAuthenticated, navigate,location]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([getdynamicdata(), getassociation()]);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);
  
  //  useEffect(() => {
  //         // Fetching upcoming events
  //         getdynamicdata()
  //         getassociation()
  //     }, []);
  const getdynamicdata = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getdynamicdata`);
    const data = res.data.reduce((acc, { fieldname, fieldvalue }) => {
      acc[fieldname] = fieldvalue;
      return acc;
    }, {});
    setDynamicData(data);
    setAchievements([
      { number: `${data.answerd}+`, text: 'Questions Answered' },
      { number: `${data.providerscnt}+`, text: 'Providers Across Industries' },
      { number: `${data.helpcnt}+`, text: 'Help Provided' },
    ]);
  };
  const getassociation = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getassociation`);
    setassociations(res.data);
  };
  return isLoading ? <LoadingScreen /> : (
    
    <Box> 
      {/* Hero Section */}
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #1976d2 30%, #42a5f5 90%)',
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          p: 4,
          position: 'relative',
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <Typography variant="h4" fontWeight="bold" mb={2}>
            {dynamicData.header || "Welcome to Udyog Connect"}
          </Typography>
          <Typography variant="h6" mb={4} maxWidth="900px" mx="auto">
            {dynamicData.headersub || "Empowering communities by connecting people who need help with those who can offer it."}
          </Typography>
          {!isAuthenticated && (
              <Button
              variant="contained"
              size="large"
              onClick={handleDialogOpen}
              sx={{
                backgroundColor: 'white',
                color: '#1976d2',
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#e3f2fd',
                },
                mb: 5,
              }}
              >
              Join Now / Login
              </Button>
          )}
         
        </motion.div>

        {/* Achievements */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          <Grid container spacing={3} justifyContent="center" mt={2}>
          {achievements.map((item, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <Card sx={{ textAlign: 'center', p: 3, borderRadius: 4, boxShadow: 6 }}>
                  <Typography variant="h4" color="primary">{item.number}</Typography>
                  <Typography variant="subtitle1">{item.text}</Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </motion.div>
        
        <Typography variant="body1" sx={{ maxWidth: '90%', mt: 3 }}>
          {dynamicData.footer || "Join our growing community of professionals and make a difference by sharing your expertise or receiving guidance in areas that matter to you. Whether you're here to lend a helping hand or seek support, Udyog Connect provides the platform to make meaningful connections."}  
        </Typography>
        <Typography variant="body2" sx={{ maxWidth: '90%', mt: 2 }}>
          {dynamicData.footer1 || "Together, we can create an ecosystem of collaboration and growth. Sign up today and be part of the change!"}
        </Typography> 
        {/* Scroll Down Indicator */}
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
          style={{ position: 'absolute', bottom: 20 }}
        >
          <KeyboardArrowDown fontSize="large" />
        </motion.div>
      </Box>
      <Newsandevents></Newsandevents>
      {/* Scrollable Content Section */}
      <Box sx={{ p: 4, height: 'auto' }} mb={2}>
        <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'space-between', height: '100%' }}>
          {/* Right: List of Industries */}
          <Grid item xs={12} sm={6} sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              style={{ height: '100%' }}
            >
              <Paper
                elevation={6}
                sx={{
                  flex: 1,
                  width: '100%',
                  p: 2,
                  borderRadius: 3,
                  textAlign: 'center',
                  height: '100%',
                }}
              >
                <Typography fontWeight="bold" gutterBottom>
                  List of Industries We Serve
                </Typography>

                {/* First Row of Industries */}
                <Grid container spacing={2} justifyContent="center" sx={{ marginBottom: 2 }}>
                  {industries.slice(0, 4).map((industry, idx) => (
                    <Grid item xs={6} sm={3} md={3} key={idx}>
                      <Paper
                        elevation={3}
                        sx={{
                          p: 2,
                          textAlign: 'center',
                          borderRadius: 3,
                          width: '120px',
                          height: '100px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          margin: '0 auto',
                        }}
                      >
                        <Avatar sx={{ bgcolor: industry.color, mb: 1 }}>
                          {industry.icon}
                        </Avatar>
                        <Typography variant="body2">{industry.name}</Typography>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
                
                {/* Second Row of Industries */}
                <Grid container spacing={2} justifyContent="center" sx={{ marginBottom: 2 }}>
                  {industries.slice(4, 8).map((industry, idx) => (
                    <Grid item xs={6} sm={3} md={3} key={idx}>
                      <Paper
                        elevation={3}
                        sx={{
                          p: 2,
                          textAlign: 'center',
                          borderRadius: 3,
                          width: '120px',
                          height: '100px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          margin: '0 auto',
                        }}
                      >
                        <Avatar sx={{ bgcolor: industry.color, mb: 1 }}>
                          {industry.icon}
                        </Avatar>
                        <Typography variant="body2">{industry.name}</Typography>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
                <Grid container spacing={2} justifyContent="center" sx={{ marginBottom: 2 }}>
                  {industries.slice(8, 12).map((industry, idx) => (
                    <Grid item xs={6} sm={3} md={3} key={idx}>
                      <Paper
                        elevation={3}
                        sx={{
                          p: 2,
                          textAlign: 'center',
                          borderRadius: 3,
                          width: '120px',
                          height: '100px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          margin: '0 auto',
                        }}
                      >
                        <Avatar sx={{ bgcolor: industry.color, mb: 1 }}>
                          {industry.icon}
                        </Avatar>
                        <Typography variant="body2">{industry.name}</Typography>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </Paper>
            </motion.div>
          </Grid>

          {/* Left: List of Associations */}
          <Grid item xs={12} sm={6} sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              style={{ height: '100%' }}
            >
              <Paper
                elevation={6}
                sx={{
                  flex: 1,
                  width: '100%',
                  p: 2,
                  borderRadius: 3,
                  textAlign: 'center',
                }}
              >
                <Typography fontWeight="bold" gutterBottom>
                  List of Associations who are already part of our community
                </Typography>
                <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
                  {associations.map((association, index) => (
                    <ListItem key={index}>
                      <ListItemAvatar>
                        <Avatar alt={association.name} src={association.logo} />
                      </ListItemAvatar>
                      <ListItemText primary={association.name} />
                    </ListItem>
                  ))}
                </Box>
                <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
                <Typography variant="body2" sx={{ marginTop: 2, fontWeight: 'bold' }}>
                  Total Associations: {associations.length}
                </Typography>
              </Paper>
            </motion.div>
          </Grid> 
        </Grid>
      </Box> 
      {/* Dialog for Join Now / Login */}
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <Login />
        <DialogActions>
          <Button onClick={handleDialogClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AboutPage;
